<template>
  <div class="row bg-white max-height-vertical max-height-auto box-overflow">

    <full-span-slide v-bind:active="active">
      
      <div class="span-16-lg span-16-mg span-16-sm span-16-xs text-center">
        <!-- class="upcase" -->
        <h1>Thank You</h1>
        <p>This project is made possible by <span class="bold">Verizon</span>.</p>
        <p>With support from The Jonathan Logan Family Foundation.</p>
        <p>Developed by <span class="bold">Futures Without Violence</span>.</p>
      </div>

      <!-- images here -->
      <div class="row margin-both-24 sponsor-image-container">
        <div class="span-4-lg span-4-md ratio-4-3 bg-image-span bg-fwv"></div>
        <div class="span-4-lg span-4-md offset-2-lg offset-2-md ratio-4-3 bg-image-span bg-verizon"></div>
        <div class="span-4-lg span-4-md offset-2-lg offset-2-md ratio-4-3 bg-image-span bg-jlff"></div>
      </div>

      <div class="span-16-lg span-16-mg span-16-sm span-16-xs text-center">
        <p>Based in part on the curricula <span class="bold">Changing Minds: A Leadership Institute for Educators and Community Partners</span> developed under <br />the Office of Juvenile Justice and Delinquency Prevention, U.S. Department of Justice, and<br /> <span class="bold">Middle School Matters</span>, a project of the Jonathan Logan Family Foundation.</p>
      </div>

      <div class="p utility disclaimer text-center">Points of view or opinions expressed in this document are those of the authors and do not necessarily represent the official position or policies of OJJDP or the U.S. Department of Justice.</div>

    </full-span-slide>

  </div>
</template>

<script>
  import full_span_slide from '../../components/organisms/full_span_slide'

  import 'nodelist-foreach-polyfill'; // ie11

  export default {
    props: ['title', 'content', 'active'],
    components: {
      'full-span-slide': full_span_slide
    }
  }

</script>

<style scoped lang="scss">
  @import '../../styles/variables';

  .margin-both-24 {
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .sponsor-image-container {
    max-width: 50%;
    margin: auto;
  }

  .bg-fwv {
    background-image: url('../../assets/img/futures.png');
  }

  .bg-verizon {
    background-image: url('../../assets/img/verizon.png')
  }

  .bg-jlff {
    background-image: url('../../assets/img/jlff.png')
  }

  .bg-image-span {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }

  .disclaimer {
    // //- removed for now for safari compatability issues
    // position: fixed;
    // bottom: 0;
    // left: 0;
    // width: calc(100% - 80px - 80px);
    // margin-left: 80px;
    font-style: italic;
    font-size: 10px;
    @media screen and (max-width: $sm-max) {
      position: relative;
      width: 100%;
      margin-left: 0px;
    }
  }
</style>


// WEBPACK FOOTER //
// sponsor_page.vue?02658d6e